import { Suspense } from "react";
import { alpha, Link, Paper, styled } from "@mui/material";
import { ControlOptions } from "leaflet";
import { useTranslation } from "react-i18next";
import { useMap } from "react-leaflet";

import { MetricScale } from "./MetricScale";
import { initialBounds } from "hooks/mapHooks";
import { MapControlBase } from "../utils/MapControlBase";
import { ZoomToStudyArea } from "./ZoomToStudyArea";
import { ErrorBoundary } from "react-error-boundary";
import { AlertErrorBoundary } from "components/boundary/AlertErrorBoundary";

interface Props extends ControlOptions {
  uuid?: string;
}

export function AttributionAndScale(props: Props) {
  const { uuid, ...controlProps } = props;
  const { t } = useTranslation();
  const flandersBounds = initialBounds;
  const map = useMap();

  function onResetToFlanders() {
    map.flyToBounds(flandersBounds, { animate: true });
  }

  return (
    <MapControlBase className="flush-to-edge" {...controlProps}>
      <Styles elevation={0}>
        <ErrorBoundary
          FallbackComponent={(props) => <AlertErrorBoundary {...props} />}
        >
          <Suspense>
            <ZoomToStudyArea uuid={uuid} />
          </Suspense>
        </ErrorBoundary>

        <Link onClick={onResetToFlanders}>{t("label.reset")}</Link>
        <MetricScale maxWidth={60} map={map} />
      </Styles>
    </MapControlBase>
  );
}

const Styles = styled(Paper)`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => theme.spacing(0.5, 2, 0.2, 2)};
  background-color: ${({ theme }) => alpha(theme.palette.common.white, 0.8)};

  .MuiLink-root {
    cursor: pointer;
  }
`;
